module.exports = __webpack_public_path__ + "static/img/gc_peeling.c412d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_peeling.png
// module id = 307
// module chunks = 1